import React, { useEffect, useState } from "react";
import { Flex, Text, Box } from "@radix-ui/themes";
import { useLocation } from 'react-router-dom';

export function StackedStatusBar({ stackedStatusBarData }) {
  const location = useLocation();
  const [partiallyOnlineColour, setPartiallyOnlineColour] = useState('var(--violet-8)');
  const [onlineColour, setOnlineColour] = useState('var(--violet-11)');
  const [isReviewsPage, setIsReviewsPage] = useState(false);

  // Colour of the status bar depends on the location
  const getStatusBarColor = () => {
    if (location.pathname.includes('/locations')){
      setPartiallyOnlineColour("var(--amber-9)");
      setOnlineColour("var(--grass-9)");
    }
    if (location.pathname.includes('/reviews')){
      setIsReviewsPage(true);
      setPartiallyOnlineColour("var(--amber-9)");
      setOnlineColour("var(--grass-9)");
    }
  }

  useEffect(() => {
    getStatusBarColor();
  }, [location.pathname]);

  // For reviews page, use positive/neutral/negative instead of online/partially/offline
  const firstValue = isReviewsPage ? stackedStatusBarData.negative : stackedStatusBarData.offline;
  const secondValue = isReviewsPage ? stackedStatusBarData.neutral : stackedStatusBarData.partially;
  const thirdValue = isReviewsPage ? stackedStatusBarData.positive : stackedStatusBarData.online;

  const firstLabel = isReviewsPage ? "Negative" : "Offline";
  const secondLabel = isReviewsPage ? "Neutral" : "Partially online";
  const thirdLabel = isReviewsPage ? "Positive" : "Online";

  return (
    <Flex height="48px" direction="column" align="start" gap="4" width="100%" style={{flex: '1 0 0'}}>
      {/* Colour Graph */}
      <Flex height="16px" align="center" 
        style={{alignSelf: "stretch", borderRadius: 'var(--radius-2)', overflow: 'hidden'}} >
        <Box as="div" className="first" style={{backgroundColor: "var(--red-9)",flexGrow: firstValue, alignSelf: "stretch"}}/>
        <Box as="div" className="second" style={{backgroundColor: `${partiallyOnlineColour}`, flexGrow: secondValue, alignSelf: "stretch"}}/>
        <Box as="div" className="third" style={{backgroundColor: `${onlineColour}`, flexGrow: thirdValue, alignSelf: "stretch"}}/>
      </Flex>
      {/* Legends for the graph */}
      <Flex align="center" gap="4">
        <Flex align="center" gap="1">
          {/* First legend */}
          <Box as="div" className="first-ellipse" style={{background: "var(--red-9)", height: "8px", width: "8px", 
            borderRadius: "4px"}}/>
          <Text size="1" weight="regular">{firstLabel}</Text>
          <Text size="1" weight="bold">{firstValue}</Text>
        </Flex>
        {/* Second legend */}
        <Flex align="center" gap="1">
          <Box as="div" className="second-ellipse" style={{background: `${partiallyOnlineColour}`, height: "8px", 
            width: "8px", borderRadius: "4px"}}/>
          <Text size="1" weight="regular">{secondLabel}</Text>
          <Text size="1" weight="bold">{secondValue}</Text>
        </Flex>
        {/* Third Legend */}
        <Flex align="center" gap="1">
          <Box as="div" className="third-ellipse" style={{background: `${onlineColour}`, height: "8px", width: "8px", 
            borderRadius: "4px"}}/>
          <Text size="1" weight="regular">{thirdLabel}</Text>
          <Text size="1" weight="bold">{thirdValue}</Text>
        </Flex>
      </Flex>
    </Flex>

  );
}

